export default function isStepCompleted(step) {
  return (
    step.completion !== null &&
    step.completion.completed
  );
}
